import { Form, Input, Button } from 'antd';
import { AxiosError } from 'axios';
import ICostCenterDTO from '../../../dtos/ICostCenterDTO';
import { useApi } from '../../../hooks/api';
import { useNotification } from '../../../hooks/notification';
import { Container } from './styles';

const validate = {
  required: '${label} é obrigatório',
};

const NewCostCenters: React.FC = () => {
  const { api } = useApi();
  const { openNotificationWithIcon } = useNotification();
  const [form] = Form.useForm();

  const handleSubmit = async (data: ICostCenterDTO): Promise<void> => {
    try {
      await api.post('costCenters', data);
      openNotificationWithIcon('success', {
        title: 'Centro de custo',
        content: 'Centro de custo cadastrado com sucesso!',
      });
      form.resetFields();
    } catch (error) {
      let errorMessage;
      if (error instanceof AxiosError) {
        errorMessage = error?.response?.data.messageResponse;
      }
      openNotificationWithIcon('error', {
        title: 'Centro de custo',
        content: errorMessage || 'Erro ao cadastrar o centro de custo!',
      });
    }
  };

  return (
    <Container>
      <h1>Cadastro de Centro de Custo</h1>
      <Form
        size="large"
        labelCol={{ flex: '110px' }}
        labelAlign="left"
        wrapperCol={{ flex: 1 }}
        labelWrap
        colon={false}
        form={form}
        validateMessages={validate}
        onFinish={handleSubmit}
      >
        <Form.Item
          name={['code']}
          label="Código"
          rules={[{ required: true }]}
          wrapperCol={{ span: 12 }}
          hasFeedback
        >
          <Input />
        </Form.Item>

        <Form.Item
          name={['description']}
          label="Descrição"
          rules={[{ required: true }]}
          wrapperCol={{ span: 12 }}
          hasFeedback
        >
          <Input />
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Salvar
        </Button>
      </Form>
    </Container>
  );
};

export default NewCostCenters;
